
import {
  defineComponent, defineAsyncComponent, reactive, toRefs, ref, provide,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { IJobModuleQuestionParseStu } from '@/views/Teacher/addJob/js/interface';
import useAnalysisHooks from '@/hooks/analysis.hooks';
import useUserHooks from '@/hooks/user.hooks';
import { message } from 'ant-design-vue';
import analysisService from '@/services/analysis.services';
import { promiseConfirm } from '@/lib/message';

export default defineComponent({
  components: {
    theAnalysis: defineAsyncComponent(() => import('@/views/Public/jobPreview/index.vue')),
    questionModules: defineAsyncComponent(() => import('@/components/teacher/jobAnalysis/questionModule.vue')),
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const userHooks = useUserHooks();
    const analysisHooks = useAnalysisHooks();
    const { saveAssignmentStatusApi, queryScoreDataByAssignIdStuCode } = analysisService();
    /** 子组件参数 */
    const comData = reactive({
      jobId: route.query.jobId as string,
      view: route.query.view as 'preview'|'see'|'submit',
      assignmentId: route.query.assignmentId as string,
      assignmentModel: route.query.assignmentModel as string,
      questionLoading: false,
      analysisScore: 0, // 得分
    });
    provide('jobView', comData.view);
    provide('userRole', userHooks.getUserInfo().role);
    provide('assignmentId', comData.assignmentId); // 分配表id
    provide('assignmentModel', comData.assignmentModel); // 分配模式

    const getScore = async () => {
      if (comData.view === 'see') {
        const score = await queryScoreDataByAssignIdStuCode(comData.assignmentId);
        comData.analysisScore = score;
      }
    };
    /** 问题模块 */
    const moduleList = ref<IJobModuleQuestionParseStu[]>([]); // 问题模块
    const initQuestion = async () => {
      comData.questionLoading = true;
      await getScore();
      const data = await analysisHooks.listQuestionDataByJobId(comData.jobId);
      const stuData = await analysisHooks.listQuestionStuAnswer(data, comData.assignmentId);
      console.log(stuData, 'data');
      moduleList.value = stuData;
      comData.questionLoading = false;
    };

    /** 提交 */
    const onSubmit = () => {
      console.log('onSubmit');
      promiseConfirm('提交后不能修改，确定提交吗?', async () => {
        await saveAssignmentStatusApi(comData.assignmentId);
        message.success('提交成功!');
        router.back();
      }, undefined, () => {
        router.back();
      });
    };

    initQuestion();
    return {
      ...toRefs(comData),
      onSubmit,
      moduleList,
      initQuestion,
    };
  },
});
